"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.styles = exports.default = void 0;
var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/esm/extends"));
var _objectWithoutProperties2 = _interopRequireDefault(require("@babel/runtime/helpers/esm/objectWithoutProperties"));
var _classCallCheck2 = _interopRequireDefault(require("@babel/runtime/helpers/esm/classCallCheck"));
var _createClass2 = _interopRequireDefault(require("@babel/runtime/helpers/esm/createClass"));
var _possibleConstructorReturn2 = _interopRequireDefault(require("@babel/runtime/helpers/esm/possibleConstructorReturn"));
var _getPrototypeOf2 = _interopRequireDefault(require("@babel/runtime/helpers/esm/getPrototypeOf"));
var _inherits2 = _interopRequireDefault(require("@babel/runtime/helpers/esm/inherits"));
var _objectSpread2 = _interopRequireDefault(require("@babel/runtime/helpers/esm/objectSpread2"));
var _react = _interopRequireDefault(require("react"));
var _IconButton = _interopRequireDefault(require("@mui/material/IconButton"));
var _Calendar = _interopRequireDefault(require("mdi-material-ui/Calendar"));
var _CustomOverlayLayout = _interopRequireDefault(require("./CustomOverlayLayout"));
var _ListPicker = _interopRequireDefault(require("../ListPicker"));
var _withStyles = _interopRequireDefault(require("@mui/styles/withStyles"));
function _callSuper(t, o, e) { return o = (0, _getPrototypeOf2.default)(o), (0, _possibleConstructorReturn2.default)(t, _isNativeReflectConstruct() ? Reflect.construct(o, e || [], (0, _getPrototypeOf2.default)(t).constructor) : o.apply(t, e)); }
function _isNativeReflectConstruct() { try { var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); } catch (t) {} return (_isNativeReflectConstruct = function _isNativeReflectConstruct() { return !!t; })(); }
var styles = exports.styles = function styles(theme) {
  return {
    paper: {
      position: 'absolute',
      width: '100%',
      zIndex: 10
    },
    overlay: (0, _objectSpread2.default)({
      padding: 0,
      height: 325,
      textAlign: 'center'
    }, theme.typography.body2),
    header: (0, _objectSpread2.default)({
      display: 'block',
      height: 40,
      textAlign: 'center',
      padding: '10px 0'
    }, theme.typography.body2, {
      color: theme.palette.neutral.main,
      borderBottom: '1px solid',
      borderBottomColor: theme.palette.divider
    }),
    titles: {
      width: 224,
      margin: 'auto'
    },
    timeTitle: {
      display: 'inline-block',
      width: '50%'
    },
    body: {
      height: 245,
      width: 224,
      margin: 'auto'
    },
    columnWrapper: {
      height: '100%',
      width: '100%'
    },
    column: {
      display: 'inline-block',
      height: '100%',
      width: '50%'
    },
    listItem: {
      height: 40,
      textAlign: 'center'
    },
    itemRoot: {
      '&:hover': {
        backgroundColor: theme.palette.hover
      }
    },
    itemSelected: {
      fontWeight: theme.typography.fontWeightMedium,
      backgroundColor: theme.palette.selected
    },
    itemCentered: {
      margin: 'auto'
    },
    footer: {
      height: 40,
      padding: '10px 0',
      borderTop: '1px solid',
      borderTopColor: theme.palette.divider
    },
    clockIconButton: {
      position: 'absolute',
      left: 0,
      bottom: 0,
      height: 32,
      width: 32,
      margin: '4px 24px'
    },
    calendarButton: {
      fontWeight: theme.typography.fontWeightMedium
    }
  };
};
var _ref = /*#__PURE__*/_react.default.createElement(_Calendar.default, null);
var TimePickerOverlay = /*#__PURE__*/function (_React$Component) {
  function TimePickerOverlay(props) {
    var _this;
    (0, _classCallCheck2.default)(this, TimePickerOverlay);
    _this = _callSuper(this, TimePickerOverlay, [props]);
    _this.hours = Array.from(Array(24).keys());
    _this.minutes = Array.from(Array(60).keys());
    _this.handleHourClick = _this.handleHourClick.bind(_this);
    _this.handleMinuteClick = _this.handleMinuteClick.bind(_this);
    return _this;
  }
  (0, _inherits2.default)(TimePickerOverlay, _React$Component);
  return (0, _createClass2.default)(TimePickerOverlay, [{
    key: "handleHourClick",
    value: function handleHourClick(hour) {
      if (this.props.onChange) {
        var date = this.props.value ? new Date(this.props.value) : new Date();
        date.setHours(hour);
        this.props.onChange(date, 'hour');
      }
    }
  }, {
    key: "handleMinuteClick",
    value: function handleMinuteClick(minute) {
      if (this.props.onChange) {
        var date = this.props.value ? new Date(this.props.value) : new Date();
        date.setMinutes(minute);
        this.props.onChange(date, 'minute');
      }
    }
  }, {
    key: "render",
    value: function render() {
      var _this$props = this.props,
        classes = _this$props.classes,
        onCalendarClick = _this$props.onCalendarClick,
        translations = _this$props.translations,
        value = _this$props.value,
        props = (0, _objectWithoutProperties2.default)(_this$props, ["classes", "onCalendarClick", "translations", "value"]);
      var hour = value ? value.getHours() : 0;
      var minute = value ? value.getMinutes() : 0;
      return /*#__PURE__*/_react.default.createElement(_CustomOverlayLayout.default, (0, _extends2.default)({
        headerElement: /*#__PURE__*/_react.default.createElement("div", {
          className: classes.titles
        }, /*#__PURE__*/_react.default.createElement("div", {
          className: classes.timeTitle
        }, translations.hour), /*#__PURE__*/_react.default.createElement("div", {
          className: classes.timeTitle
        }, translations.minute)),
        absoluteElement: /*#__PURE__*/_react.default.createElement(_IconButton.default, {
          className: classes.clockIconButton,
          onClick: function onClick() {
            return onCalendarClick();
          },
          size: "large"
        }, _ref)
      }, props), /*#__PURE__*/_react.default.createElement("div", {
        className: classes.column
      }, /*#__PURE__*/_react.default.createElement(_ListPicker.default, {
        itemList: this.hours,
        onItemClick: this.handleHourClick,
        selectedItem: hour
      })), /*#__PURE__*/_react.default.createElement("div", {
        className: classes.column
      }, /*#__PURE__*/_react.default.createElement(_ListPicker.default, {
        itemList: this.minutes,
        onItemClick: this.handleMinuteClick,
        selectedItem: minute
      })));
    }
  }]);
}(_react.default.Component);
TimePickerOverlay.defaultProps = {
  translations: {
    hour: 'Hour',
    minute: 'Minute'
  }
};
var _default = exports.default = (0, _withStyles.default)(styles, {
  name: 'HmuiTimePickerOverlay'
})(TimePickerOverlay);